import React from 'react';
import { useIsMobile } from '../hooks/useIsMobile';
import { PassOnItem, WeekData } from '../data/mockData';
interface ShiftContinuityProps {
  passOnItems: PassOnItem[];
  shiftContinuityCopy: WeekData['shiftContinuityCopy'];
}
export function ShiftContinuity({
  passOnItems,
  shiftContinuityCopy: c
}: ShiftContinuityProps) {
  const isMobile = useIsMobile();
  return <div style={{
    background: '#111827',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: '10px',
    padding: isMobile ? '14px 16px' : '16px 20px',
    display: 'flex',
    flexDirection: 'column'
  }} data-id="element-50">
      {/* Section header */}
      <div style={{
      marginBottom: '14px'
    }} data-id="element-51">
        <div style={{
        fontSize: '10px',
        fontWeight: 700,
        color: '#4e5f74',
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        marginBottom: '2px'
      }} data-id="element-52">
          {c.sectionLabel}
        </div>
        <div style={{
        fontSize: '14px',
        fontWeight: 600,
        color: '#e8edf4'
      }} data-id="element-53">
          {c.title}
        </div>
      </div>

      {/* Entries */}
      <div style={{
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-54">
        {passOnItems.map((item, idx) => <div key={item.id} style={{
        padding: '10px 0',
        borderBottom: idx < passOnItems.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none'
      }} data-id="element-55">
            {/* Officer + time — visually distinct header line */}
            <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          marginBottom: '3px'
        }} data-id="element-56">
              <span style={{
            fontSize: '11px',
            fontWeight: 700,
            color: '#7a8a9e',
            letterSpacing: '0.01em'
          }} data-id="element-57">
                {item.officer}
              </span>
              <span style={{
            fontSize: '10px',
            color: 'rgba(255,255,255,0.1)'
          }} data-id="element-58">
                ·
              </span>
              <span style={{
            fontSize: '11px',
            color: '#3e4f62',
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-59">
                {item.timeLabel}
              </span>
            </div>
            {/* Narrative body — consistent left alignment */}
            <p style={{
          fontSize: '13px',
          color: '#8b9ab0',
          lineHeight: '1.55',
          margin: 0
        }} data-id="element-60">
              {item.message}
            </p>
          </div>)}
      </div>

      {/* Footer */}
      <div style={{
      marginTop: '12px',
      paddingTop: '10px',
      borderTop: '1px solid rgba(255,255,255,0.04)',
      fontSize: '11px',
      color: '#3e4f62'
    }} data-id="element-61">
        {c.footer}
      </div>
    </div>;
}